import * as React from "react";
import { useHistory } from "react-router-dom";
import roles from "../../auth/roles";
import { Button, UncontrolledPopover, Row, Col, PopoverHeader, PopoverBody, ButtonGroup, UncontrolledTooltip } from "reactstrap";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TenantMenu from "./Tenant";

const HomeLink = ({ roots }) => {
  const { activeTenant, user, isAuthenticated } = useAuth0();
  const { push } = useHistory();
  const isAdminPath = window.location.pathname.includes(roots.ADMIN) || window.location.pathname.includes(roots.BACKOFFICE);

  const onClick = () => {
    push(isAdminPath ? "/" : `/?from=${window.location.pathname}`);
  };

  const isTenantSelect = [
    roles.DEALER,
    roles.VENDITORE,
    roles.AGENTE,
    roles.ADMIN,
    roles.MARKETING,
    roles.BACKOFFICE,
    roles.SERVICE
  ].includes(user.getRole());


  const getButton = () => {
    if (activeTenant && !isTenantSelect) {
      return (
        <Button color="success" onClick={onClick}>
          <FontAwesomeIcon icon="home" className="mr-1" /> Home
        </Button>
      );
    }
    else if (isTenantSelect && activeTenant) {

      const { geo } = useAuth0();

      return (
        <ButtonGroup>
          <Button id="swapTenantNavBtn" onClick={onClick} color="success">
            <FontAwesomeIcon icon="sync" />
          </Button>

          <Button
            id="activeTenantNavbarTrigger"
            className="tenant-selected-btn"
            color="success"
          >
            {activeTenant.name}
            {getTenantPopover(activeTenant, geo)}
          </Button>

          <TenantMenu path={roots.DEALER} />
          <UncontrolledTooltip placement="auto" popperClassName="tooltip-success" target="swapTenantNavBtn">
            Seleziona un altro Dealer
          </UncontrolledTooltip>
        </ButtonGroup>
      );
    } else {
      return (
        <Button color="success" onClick={onClick} className="home-link-button">
          Impostare il Dealer attivo
        </Button>
      );
    }
  };

  if (!user || !isAuthenticated) {
    return null;
  }

  return getButton();
};


const getTenantPopover = (activeTenant, geo) => (

  <UncontrolledPopover
    placement="auto"
    trigger="focus"
    target="activeTenantNavbarTrigger"
    popperClassName="tooltip-secondary"
  >
    <PopoverHeader>Dealer selezionato:</PopoverHeader>
    <PopoverBody>
      <Row>
        <Col>
          <div>
            <strong className="d-block">Nominativo:</strong>
            {activeTenant.name}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <strong className="d-block">C.F. / P.iva:</strong>
            {`${activeTenant.taxCode || ""} ${activeTenant.vatCode || ""}`}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <strong className="d-block">Indirizzo:</strong>
            {`${activeTenant.address.street} - ${
              activeTenant.address.cap
              } ${geo.getComuneLabel(activeTenant.address.city)} (${activeTenant.address.province.toUpperCase()})`}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <strong className="d-block">Contatti:</strong>
            {`${activeTenant.email ||
              activeTenant.attributes.email ||
              ""} / ${activeTenant.phone ||
              activeTenant.attributes.phone ||
              ""}`}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div>
            <strong className="d-block">Riferimento:</strong>
            {`${activeTenant.reference1 ||
              activeTenant.attributes.reference1 ||
              ""}`}
          </div>
        </Col>
      </Row>
    </PopoverBody>
  </UncontrolledPopover>
);

export default HomeLink;
